import { MedicalLeaveUpdateCommand } from '@dreryk/egabinet-ezla-frontend-api';
import { VisitMedicalLeaveCreateDraftCommand } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { RouteLeavingGuard } from '@dreryk/react-components';
import { Choice } from '@dreryk/watermelon';

import { useVisitDocumentContext } from '../../../common/visitDocument/VisitDocumentContext';
import { commonTranslationKeys } from '../../../translations';
import { medicalLeaveDraftCommandTransformer } from '../common/common.utils';

import { MedicalLeaveFormBean, MedicalLeaveFormController } from './medicalLeave.types';

type MedicalLeaveUpdateParameters = { formData: MedicalLeaveFormBean; externalId: string };

type MedicalLeaveFormRouteLeavingGuardProps = Pick<MedicalLeaveFormController, 'handleSubmitDraft'> & {
   readonly active: boolean;
};

export const MedicalLeaveFormRouteLeavingGuard = (props: MedicalLeaveFormRouteLeavingGuardProps): JSX.Element => {
   const { executeVisitDocumentCommand } = useVisitDocumentContext();
   const { executeAsync: updateMedicalLeaveDraft } = useCqrsCommand<void, MedicalLeaveUpdateParameters>(
      (parameters) => {
         // eslint-disable-next-line @typescript-eslint/no-unused-vars
         const { diagnosis, leaveDaysCount, ...restFormFields } = parameters.formData;

         const command = new MedicalLeaveUpdateCommand();
         medicalLeaveDraftCommandTransformer<MedicalLeaveUpdateCommand>(parameters.externalId, command, restFormFields);
         command.medicalLeaveDetails.icd10Code = diagnosis?.getCode()
            ? Choice.of(diagnosis.getCode().asString())
            : undefined;
         return command;
      }
   );

   return (
      <RouteLeavingGuard
         title={commonTranslationKeys.draftSaveFailTitle}
         message={commonTranslationKeys.draftSaveFailMessage}
         active={props.active}
         onLeave={props.handleSubmitDraft(async (formData) => {
            return executeVisitDocumentCommand(VisitMedicalLeaveCreateDraftCommand, async (externalId) =>
               updateMedicalLeaveDraft({ formData: formData, externalId: externalId })
            );
         })}
         successMessage={commonTranslationKeys.draftSaveSuccessMessage}
         testId='medicalLeaveRouteLeaving'
      />
   );
};
